import { HAS_SEEN_SMART_SEARCH_PROMOTION, PRIVATE_SEARCH_TYPE } from '~/constants/localStorageKeys';

const DEFAULT_SEARCH_TYPE = 'keyword';

export type SearchType = 'keyword' | 'smart';

const isValidSearchType = (value: string | null): value is SearchType => {
  return value === 'keyword' || value === 'smart';
};

export const DEFAULT_CONTEXT = 'all';
export const getLocalStorageKey = (context: string) => `${PRIVATE_SEARCH_TYPE}/${context}`;

export const getLastUsedSearchType = (context: string) => {
  const localStorageKey = getLocalStorageKey(context);
  const lastUsedSearchType = localStorage.getItem(localStorageKey);

  return isValidSearchType(lastUsedSearchType) ? lastUsedSearchType : DEFAULT_SEARCH_TYPE;
};

export const setLastUsedSearchType = (type: SearchType, context: string) => {
  const localStorageKey = getLocalStorageKey(context);
  localStorage.setItem(localStorageKey, type);
};

export const getLocalStorageKeyHasSeenSmartSearchPromotion = (context: string) => {
  return `${HAS_SEEN_SMART_SEARCH_PROMOTION}/${context}`;
};

export const getHasSeenSmartSearchPromotion = (context: string = DEFAULT_CONTEXT) => {
  const localStorageKey = getLocalStorageKeyHasSeenSmartSearchPromotion(context);
  const hasSeenSmartSearchPromotion = localStorage.getItem(localStorageKey);

  return hasSeenSmartSearchPromotion === 'true';
};

export const setHasSeenSmartSearchPromotion = (hasSeen: boolean, context: string = DEFAULT_CONTEXT) => {
  const localStorageKey = getLocalStorageKeyHasSeenSmartSearchPromotion(context);
  localStorage.setItem(localStorageKey, hasSeen ? 'true' : 'false');
};
